import React from 'react'

import { Group, rem, Skeleton, Stack } from '@affstore-ds/uikit'

import { usePromoCardLoaderStyles } from './PromoCardLoader.styled'

export const PromoCardLoader = () => {
  const { classes } = usePromoCardLoaderStyles()

  return (
    <Stack className={classes.root} mih={rem(672)} w="100%">
      {/* Image Section */}
      <Skeleton borderRadius={0} height={262} mah={262} w="100%" />

      {/* Card Content */}
      <Stack flex={1} gap={16} p={16} pt={12} w="100%">
        {/* Badges Section */}
        <Group gap={8} wrap="wrap">
          <Skeleton borderRadius={8} height={24} w={200} />
        </Group>

        {/* Title */}
        <Skeleton borderRadius={8} height={24} w={180} />

        {/* Description */}
        <Stack gap={0}>
          <Skeleton borderRadius={8} height={24} w="100%" />
        </Stack>

        {/* Extra Content Area */}
        <Stack gap={16}>
          <Skeleton borderRadius={8} height={40} w="60%" />
        </Stack>

        {/* Generate Link Button */}
        <Skeleton borderRadius={8} height={40} mt="auto" w="100%" />
      </Stack>
    </Stack>
  )
}
